<template>
  <b-container>
    <b-breadcrumb>
      <b-breadcrumb-item :to="{name: 'ward-list', params: { wardId: wardId}}">Back to {{ward.ward_name}}</b-breadcrumb-item>
      <b-breadcrumb-item active>Twilio Profiles</b-breadcrumb-item>
    </b-breadcrumb>
    <h3>Setup Twilio Helper - Profiles</h3>
    <b-card>
      <b-table
        :fields="profile_table.fields"
        :items="profile_table.items"
        :busy="profile_table.isBusy"
        light
        responsive
        show-empty
        empty-text="No Profiles to Show"
        outlined>
      </b-table>
    </b-card>
  </b-container>
</template>
<script>
import { WardApi } from "@/app/wards/wardApi";
import { StakeApi } from "@/app/stakes/stakeApi";
import { ROOT_URL } from "@/setup/constants";
import { userMixin } from "@/mixins/userMixin";
import handleError from "@/errorHandler";
export default {
  name: "WardTwilioSetUp",
  props: {
    wardId: {
      type: String,
      required: true
    }
  },
  mixins: [userMixin],
  data () {
    return {
      ward: null,
      twilioProfiles: null,
      profile_table: {
        id: "ward-twilio-profiles",
        isBusy: false,
        fields: [
          {
            key: "sid",
            label: "Profile ID"
          },
          {
            key: "status",
            label: "Twilio Status"
          },
          {
            key: "email",
            label: "Contact Email"
          },
          {
            key: "friendly_name",
            label: "Friendly Name"
          }
        ],
        items: [],
        totalRows: 0
      }

    }
  },
  async mounted() {
    if(this.wardId!==null) {
      this.ward = await this.getWard();
      await this.getTwilioProfiles();
    }
  },
  methods: {
    async getWard() {
      try{
        const { data } = await WardApi.getWardDetail(this.wardId);
        return data.ward;
      } catch(e) {
        handleError(e, "Error trying to get Ward Information");
      }
    },
    async getTwilioProfiles() {
      try {
        const { data } = await WardApi.getWardTwilioProfiles(this.wardId);
        this.profile_table.items = data.profiles;
        this.profile_table.totalRows = data.count;
      } catch(e) {
        handleError(e, "Error trying to get Twilio Profiles");
      }
    }
  }
}
</script>
